// stores/linkStore.js
import { defineStore } from "pinia";
import { ref } from "vue";
import { useAuthStore } from "./authStore";
import { useRoomStore } from "./roomStore";
import {
  getLinkStatus,
  // getUserLinkStatus,
  // getAnchorStatus,
  // userGetAnchorStatus,
} from "@/api/linkApi";
import { fetchWithAuth } from "@/api/fetchApi"; // ✅ これを追加！

export const useLinkStore = defineStore("linkStore", () => {
  const isLinking = ref(false);
  const isRoomLinking = ref(false); // ✅ 追加
  const isUserLinking = ref(false); // ✅ 追加
  const isAnchored = ref(false);

  const checkInterval = 3000;
  let intervalId = null;
  let anchorIntervalId = null;

  const fetchLinkStatus = async () => {
    const roomStore = useRoomStore();
    const authStore = useAuthStore();
    const roomNumber = roomStore.selectedRoom?.number;
    const email = authStore.user?.email || "";

    console.log(
      "🔍 fetchLinkStatus: roomNumber =",
      roomNumber,
      ", email =",
      email
    );

    try {
      const res = await getLinkStatus(roomNumber, email);
      console.log("📥 getLinkStatus response:", res);

      isRoomLinking.value = !!res?.isRoomLinking;
      isUserLinking.value = !!res?.isUserLinking;
      isLinking.value = isRoomLinking.value || isUserLinking.value;
    } catch (err) {
      console.error("❌ fetchLinkStatus failed:", err);
      isLinking.value = false;
      isRoomLinking.value = false;
      isUserLinking.value = false;
    }
  };

  const fetchAnchorStatus = async () => {
    const roomStore = useRoomStore();
    const roomNumber = roomStore.selectedRoom?.number;

    try {
      const res = await getAnchorStatus(roomNumber); // ✅ roomNumberはfallback用
      isAnchored.value = !!res?.is_anchored;
      console.log("📍 anchorStatus:", res);
    } catch (err) {
      console.error("❌ fetchAnchorStatus failed:", err);
      isAnchored.value = false;
    }
  };

  // const fetchLinkStatus = async () => {
  //   // const authStore = useAuthStore();
  //   const roomStore = useRoomStore();
  //   const roomNumber = roomStore.selectedRoom?.number;

  //   console.log("🔍 fetchLinkStatus: roomNumber =", roomNumber);
  //   try {
  //     let roomLinking = false;
  //     let userLinking = false;

  //     // 👤 ユーザーリンク状態取得
  //     const userRes = await getUserLinkStatus();
  //     userLinking = !!userRes?.is_linking;
  //     isUserLinking.value = userLinking;

  //     // 🏠 ルームリンク状態取得
  //     if (roomNumber) {
  //       const roomRes = await getLinkStatus(roomNumber);
  //       roomLinking = !!roomRes?.is_linking;
  //       isRoomLinking.value = roomLinking;
  //       console.log("🏠 roomLinkStatus:", roomRes);
  //     } else {
  //       isRoomLinking.value = false;
  //     }
  //     console.log("👤 userLinkStatus:", userRes);
  //     isLinking.value = roomLinking || userLinking;
  //   } catch (err) {
  //     console.error("❌ fetchLinkStatus failed:", err);
  //     isLinking.value = false;
  //     isRoomLinking.value = false;
  //     isUserLinking.value = false;
  //   }
  // };

  async function getAnchorStatus(roomNumber = null) {
    try {
      const auth = useAuthStore();
      const params = new URLSearchParams();
      if (auth.user?.email) {
        params.append("email", auth.user.email); // ✅ email優先
      } else if (roomNumber) {
        params.append("room_number", roomNumber);
      }

      const res = await fetchWithAuth(`/anchor-status/?${params.toString()}`, {
        method: "GET",
      });
      return res; // { is_anchored: true/false }
    } catch (err) {
      console.error("❌ getAnchorStatus failed:", err);
      return { is_anchored: false };
    }
  }
  // const fetchAnchorStatus = async () => {
  //   const roomStore = useRoomStore();
  //   const roomNumber = roomStore.selectedRoom?.number;

  //   try {
  //     let res;
  //     if (isUserLinking.value) {
  //       res = await userGetAnchorStatus();
  //     } else if (roomNumber) {
  //       res = await getAnchorStatus(roomNumber);
  //     } else {
  //       isAnchored.value = false;
  //       return;
  //     }
  //     isAnchored.value = !!res?.is_anchored;
  //     console.log("📍 anchorStatus:", res);
  //   } catch (err) {
  //     console.error("❌ fetchAnchorStatus failed:", err);
  //     isAnchored.value = false;
  //   }
  // };

  // const fetchAnchorStatus = async () => {
  //   const roomStore = useRoomStore();
  //   const roomNumber = roomStore.selectedRoom?.number;
  //   if (!roomNumber) return;

  //   try {
  //     const res = await getAnchorStatus(roomNumber);
  //     isAnchored.value = !!res?.is_anchored;
  //     console.log("📍 anchorStatus:", res);
  //   } catch (err) {
  //     console.error("❌ fetchAnchorStatus failed:", err);
  //     isAnchored.value = false;
  //   }
  // };

  const startPolling = () => {
    if (intervalId) return;
    fetchLinkStatus();
    intervalId = setInterval(fetchLinkStatus, checkInterval);
  };

  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    isLinking.value = false;
    isRoomLinking.value = false;
    isUserLinking.value = false;
  };

  const startAnchorPolling = () => {
    if (anchorIntervalId) return; // ✅ 修正: .value 不要
    fetchAnchorStatus(); // 初回即実行
    anchorIntervalId = setInterval(fetchAnchorStatus, 3000);
  };

  const stopAnchorPolling = () => {
    if (anchorIntervalId) {
      clearInterval(anchorIntervalId);
      anchorIntervalId = null;
    }
  };

  return {
    isLinking,
    isRoomLinking,
    isUserLinking,
    isAnchored,
    startPolling,
    stopPolling,
    fetchLinkStatus,
    startAnchorPolling,
    stopAnchorPolling,
    fetchAnchorStatus,
    getAnchorStatus,
  };
});
